import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import handlePostRequest from '../utils/requestHandler';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
// import fetch from 'node-fetch'; 
import { translate } from '../utils/languageMap';
import { useSearchParams } from 'react-router-dom';
const baseUrl = process.env.REACT_APP_BASE_URL;

export function Copyright(props: any) {
    return (
        <>
            <Typography variant="body2" color="text.secondary" align="center" {...props}>
                {'This site is protected by hCaptcha and its '}
                <Link color="inherit" href="https://www.hcaptcha.com/privacy">
                    Privacy Policy
                </Link>{' '}
                {' and '}
                <Link color="inherit" href="https://www.hcaptcha.com/terms">
                    Terms of Service
                </Link>{' '}
                {" apply "}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center" {...props}>
                {'Suport email: support@mobilauto.com.ua'}
            </Typography>
        </>

    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export function SearchResults(paramName: string): any {
    const [searchParams, setSearchParams] = useSearchParams();

    return searchParams.get(paramName);
}

export default function Delete() {
    const navigate = useNavigate();
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [companyId, setCompanyId] = React.useState(null);
    const [accountId, setAccountId] = React.useState(null);
    const [url, setUrl] = React.useState(new URL(window.location.href));

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        if (data.get('login') === "" || data.get('password') === "") { setError(true) } else {
            const result = await handlePostRequest(`/delete-user/${companyId}`, {
                login: data.get('login'),
                password: data.get('password'),
            });
            console.log("handleSubmit delete result", result);
            if (!result.error) {
                setSuccess(true);
                setError(false);
            } else {
                setError(true);
                setSuccess(false);
            }
        }
    };

    const checkCompany = async () => {
        const segments = url.pathname.split('/').filter(Boolean); // filter(Boolean) is used to remove empty strings
        const accountId = segments[segments.length - 2]; // This will be '1'
        const companyId = segments[segments.length - 1]; // This will be '2'
        setAccountId(accountId);
        setCompanyId(companyId);

        // console.log("AccountId", accountId);
        // console.log("CompanyId", companyId);
        // console.log("baseUrl", baseUrl);
        // console.log("Nav-Lang", navigator.language.split('-')[0]);

        try {
            const response = await axios.get(`${baseUrl}/check/${companyId}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log("response checkCompany", response);

            if (response.data) {
                console.log("success");
            } else {
                navigate('/NotFound');
            }
        } catch (error) {
            console.error('Network error:', error);
            setError(true)
            navigate('/NotFound');
        }

    }

    const lang = SearchResults('lang');

    React.useEffect(() => {
        checkCompany()
    }, []);

    const uri = "https://miro.medium.com/v2/resize:fit:1400/0*nWb6nvGBuNVcMZM0"

    return (
        <ThemeProvider theme={defaultTheme}>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={6}
                    sx={{
                        backgroundImage: `url(${uri})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        // backgroundColor: "red"
                    }}
                />
                <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                            {/* <LockOutlinedIcon /> */}
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            {translate("Authorization", lang)}
                        </Typography>

                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="login"
                                label={translate("Login", lang)}
                                name="login"
                                autoComplete="login"
                                autoFocus
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label={translate("Password", lang)}
                                type="password"
                                id="password"
                                autoComplete="current-password"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                {translate("Delete", lang)}
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Link href={`${url.pathname}forgot${url.search}`} variant="body2">
                                        {translate("Forgot password", lang)}
                                    </Link>
                                </Grid>
                                {success && <Typography variant="body2" color={"green"}>
                                    {translate("Successfully removed", lang)}
                                </Typography>}
                                {error && <Typography variant="body2" color={"red"}>
                                    {translate("Check the data is correct", lang)}
                                </Typography>}
                            </Grid>
                            <Copyright sx={{ mt: 5 }} />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}

